// Remito number entry: four digits of punto de venta, then eight of número.
// Digits typed past a full punto de venta (fast typing, or pasting "0001-00000045") belong to the
// número, so they are carried over instead of dropped.
const PUNTO_VENTA_LENGTH = 4;
const NUMERO_LENGTH = 8;

const digitsOf = (value) => String(value || '').replace(/\D/g, '');

export function applyPuntoVentaInput(value, currentNumero = '') {
  const digits = digitsOf(value);
  const overflow = digits.slice(PUNTO_VENTA_LENGTH, PUNTO_VENTA_LENGTH + NUMERO_LENGTH);
  return {
    punto_venta: digits.slice(0, PUNTO_VENTA_LENGTH),
    numero_remito: currentNumero || overflow,
    advance: digits.length >= PUNTO_VENTA_LENGTH,
  };
}

export function applyNumeroRemitoInput(value) {
  const numero = digitsOf(value).slice(0, NUMERO_LENGTH);
  return { numero_remito: numero, advance: numero.length === NUMERO_LENGTH };
}
